import { render, staticRenderFns } from "./Wjsp.vue?vue&type=template&id=68fcf6fb&scoped=true"
import script from "./Wjsp.vue?vue&type=script&lang=js"
export * from "./Wjsp.vue?vue&type=script&lang=js"
import style0 from "./Wjsp.vue?vue&type=style&index=0&id=68fcf6fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fcf6fb",
  null
  
)

export default component.exports